<template>
    <div>
        <Header />
        <ModuleMenu 
            v-if="loadMenu"
            :moduleKey="$route.params.mid"
            :projectId="$route.params.pid" />
        <ModuleOverviewInfo />
   </div>
</template>

<script>
    import Header from './Header'
    import ModuleMenu from './ModuleMenu'
    import ModuleOverviewInfo from './ModuleOverviewInfo'
    import { dynamicTitle } from './utilities';

    export default {
        name: 'ModuleOverview',
        
        data () {
            return {
                loadMenu: false
            }
        },
        
        components: {
            Header,
            ModuleMenu,
            ModuleOverviewInfo
        },

        created () {
            document.title = dynamicTitle( 'Module Overview: ', this.$route.params )
        },

        mounted() {
            setTimeout( () => {
                this.loadMenu = true
            }, 250)
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/ModuleOverview.vue